module.exports = __webpack_public_path__ + "img/banner-international-air.b51e60cc.png";